import { FirebaseOptions } from '@firebase/app-types';
import { BingTranslatorSettings } from './api/bingTranslatorApi'

interface Config {
    firebaseConfig : FirebaseOptions;
    bingSettings : BingTranslatorSettings
}

const config : Config = {
    firebaseConfig: {
        apiKey: "AIzaSyB2Vl4S4beF4lZgCnubD6rSiTWfk6xKHLc",
        projectId: "eugene-languageproject",
        authDomain: "eugene-languageproject.firebaseapp.com",
        databaseURL: "https://eugene-languageproject.firebaseio.com/"
    },
    bingSettings: {
        url: "https://api-eur.cognitive.microsofttranslator.com",
        secret: "e0a2ba536031428399a2d80246af4bd7"
    }
}

export default config;